import { Capacitor } from '@capacitor/core';

/** True lorsque l’app tourne dans le conteneur Capacitor (APK / IPA). */
export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

/** Origine utilisée pour les redirections OAuth dans le WebView natif. */
export function getNativeOrigin(): string {
  return 'https://localhost';
}

export function getOAuthRedirectUrl(): string {
  if (isNativeApp()) {
    return `${getNativeOrigin()}/auth/callback`;
  }
  return `${window.location.origin}/auth/callback`;
}

/** Retour après clic sur le lien « mot de passe oublié » (e-mail). */
export function getPasswordRecoveryRedirectUrl(): string {
  return getOAuthRedirectUrl();
}
